

export default function Footer() {
    return (
        <footer className="footer">
            <p className="text-md">Made with ❤️ in PFKNR🇵🇷</p>
        </footer>
    );
}